import { useState, useEffect } from "react";
import { fetchReferees } from "../api";

function Referees() {
  const [refereeStats, setRefereeStats] = useState([]);
  const [view, setView] = useState("average");

  useEffect(() => {
    fetchReferees().then((res) => {
      setRefereeStats(res.data);
    });
  }, []);

  const sorted =
    view === "total"
      ? [...refereeStats].sort((a, b) => b.totalCards - a.totalCards)
      : [...refereeStats].sort((a, b) => b.cardsPerGame - a.cardsPerGame);

  const metric = view === "total" ? "totalCards" : "cardsPerGame";
  const label = view === "total" ? "Total Cards" : "Cards Per Game";

  return (
    <div className="container">
      <h1 className="fw-bold text-center mb-4">Referees</h1>

      <div className="mb-3">
        <select
          className="form-select w-auto"
          value={view}
          onChange={(e) => setView(e.target.value)}
        >
          <option value="average">Cards per game</option>
          <option value="total">Total cards</option>
        </select>
      </div>

      <table className="table table-striped table-hover bg-white shadow-sm">
        <thead>
          <tr>
            <th style={{ backgroundColor: "#1A56DB", color: "white" }}>
              Referee
            </th>
            <th style={{ backgroundColor: "#1A56DB", color: "white" }}>
              Games
            </th>
            <th style={{ backgroundColor: "#1A56DB", color: "white" }}>
              {label}
            </th>
          </tr>
        </thead>
        <tbody>
          {sorted.map((ref) => (
            <tr key={ref.name}>
              <td>{ref.name}</td>
              <td>{ref.gamesRefereed}</td>
              <td>{ref[metric]}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default Referees;
